import React from 'react';
import classNames from 'classnames';
import styles from './Divider.module.scss';
/** Mirrors WUT's `direction` state (`Divider.st.css`: `direction(enum(vertical, horizontal))`). */
export const DividerDirection = {
    horizontal: 'horizontal',
    vertical: 'vertical',
};
/**
 * Drop-in replacement for `Divider` from `wix-ui-tpa/cssVars`.
 *
 * Renders an `<hr>` with the `direction` state class, exactly as WUT does — all of the border
 * declarations live on that state, so the class has to be emitted or nothing draws.
 */
export const Divider = ({ className, 'data-hook': dataHook }) => (React.createElement("hr", { className: classNames(styles.root, styles['direction-horizontal'], className), "data-hook": dataHook }));
//# sourceMappingURL=Divider.js.map